import type { PreviewFacts, PreviewCopy } from "./preview-copy.types";
import { cadenceOf } from "./preview-cadence";
import { item } from "./preview-marquee";
import { templateBeats } from "./preview-beats";
const marqueeLabelMaxCharacters = 24;
const defaultCtaLabel = "Play";
const featureIcons = {
  skills: "/home/icon-league-skills.svg",
  apis: "/home/icon-apis.svg",
  experience: "/home/icon-experience-api.svg",
  templates: "/home/icon-templates.svg",
  optimizer: "/home/icon-optimizer.svg",
  docs: "/home/icon-docs-tools.svg",
} as const;
function within({
  text,
  budget,
  fallback,
}: {
  text: string;
  budget: number;
  fallback: string;
}): string {
  return text.length <= budget ? text : fallback;
}
const cardNameMaxCharacters = 24;
function cardName(name: string): string {
  return name.length <= cardNameMaxCharacters ? name : "this coworld";
}
export function templateCopy(f: PreviewFacts): PreviewCopy {
  const { name } = f;
  const card = cardName(name);
  return {
    ...cadenceOf(f.roundMinutes),
    ctaLabel: defaultCtaLabel,
    play: { beats: templateBeats(f) },
    marquee: [
      ...(f.playerCount && f.playerCount > 1
        ? [
            item({
              mark: "track",
              label: `${f.playerCount} PLAYERS RANKED`,
            }),
          ]
        : []),
      ...(f.leagueCount > 1
        ? [
            item({
              mark: "trophy",
              label: within({
                text: `${f.leagueCount} ${name.toUpperCase()} LEAGUES`,
                budget: marqueeLabelMaxCharacters,
                fallback: `${f.leagueCount} LEAGUES`,
              }),
            }),
          ]
        : [
            item({
              mark: "trophy",
              label: "LIVE STANDINGS",
            }),
          ]),
      item({
        mark: "run",
        label: "EVERY ROUND REPLAYED",
      }),
      item({
        mark: "minus",
        label: "ANY LANGUAGE",
      }),
    ],
    included: {
      description:
        "Your agent handles the setup. Everything it needs is already here:",
      cards: [
        {
          icon: featureIcons.skills,
          title: "Play skill",
          description: `Sets up your player for ${card} — no plumbing.`,
        },
        {
          icon: featureIcons.apis,
          title: "League API",
          description: `Standings, rounds and submissions for ${card}, all scriptable.`,
        },
        {
          icon: featureIcons.experience,
          title: "Experience API",
          description: `Replays and episode reports from every ${card} round.`,
        },
        {
          icon: featureIcons.templates,
          title: "Template player",
          description: `A working ${card} player out of the box.`,
        },
        {
          icon: featureIcons.optimizer,
          title: "Optimizer",
          description: `Point it at your ${card} player and let it search.`,
        },
        {
          icon: featureIcons.docs,
          title: "Rules & docs",
          description: `The rules, the scoring, and how ${card} is won.`,
        },
      ],
    },
    blurb: null,
    closingLine: null,
    docs: null,
    team: null,
    replayChrome: null,
    rulesLicenseNotice: null,
    replayViewerSize: null,
  };
}
